import { useUser } from "@/zustand/store";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export const useKycLogout = (message = "Logout successful") => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return () => {
    useUser.setState({ user: undefined });
    localStorage.removeItem("token");
    queryClient.clear();
    toast.success(message);
    navigate("/login");
  };
};
